import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo-centrao.png';

export default function TrocarSenha() {
  const { user, trocarSenha, logout } = useAuth();
  const navigate = useNavigate();
  const primeiroAcesso = !!user?.precisa_trocar_senha;

  const [senhaAtual, setSenhaAtual] = useState('');
  const [senhaNova, setSenhaNova] = useState('');
  const [confirma, setConfirma] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setErro('');
    if (senhaNova.length < 6) return setErro('A nova senha precisa ter pelo menos 6 caracteres.');
    if (senhaNova !== confirma) return setErro('A confirmação não bate com a nova senha.');

    setCarregando(true);
    try {
      await trocarSenha(senhaAtual, senhaNova);
      navigate('/');
    } catch (err) {
      setErro(err.response?.data?.error || 'Não foi possível trocar a senha.');
    } finally {
      setCarregando(false);
    }
  }

  return (
    <div className="login-bg">
      <form className="login-card" onSubmit={onSubmit}>
        <img src={logo} alt="Centrão" className="logo" />
        <h1>{primeiroAcesso ? 'Defina sua senha' : 'Trocar senha'}</h1>
        <p className="subtitle">
          {primeiroAcesso
            ? 'Primeiro acesso: escolha uma senha nova pra continuar.'
            : 'Atualize a senha da sua conta.'}
        </p>

        {erro && <div className="erro">{erro}</div>}

        <label htmlFor="senha-atual">
          {primeiroAcesso ? 'Senha atual (6 primeiros dígitos do CPF)' : 'Senha atual'}
        </label>
        <input
          id="senha-atual"
          type="password"
          autoComplete="current-password"
          value={senhaAtual}
          onChange={(e) => setSenhaAtual(e.target.value)}
          autoFocus
          required
        />

        <label htmlFor="senha-nova">Nova senha</label>
        <input
          id="senha-nova"
          type="password"
          autoComplete="new-password"
          value={senhaNova}
          onChange={(e) => setSenhaNova(e.target.value)}
          required
        />

        <label htmlFor="senha-confirma">Confirmar nova senha</label>
        <input
          id="senha-confirma"
          type="password"
          autoComplete="new-password"
          value={confirma}
          onChange={(e) => setConfirma(e.target.value)}
          required
        />

        <button type="submit" className="btn-centrao w-100" disabled={carregando}>
          {carregando ? 'Salvando…' : 'Salvar senha'}
        </button>

        <button
          type="button"
          className="btn-link-sair"
          onClick={() => { logout(); navigate('/login'); }}
        >
          Sair
        </button>
      </form>
    </div>
  );
}
